module.exports = __webpack_public_path__ + "media/images/instagram-6b895561221743bb41361b8fd9ee17ae.svg";